import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServerUrlService } from 'src/app/services/server-url.service';
import { CreateUsuarioType } from '../interfaces/usuario';

@Injectable({
  providedIn: 'root'
})
export class VinculoUsuariosService {

  constructor(
    private http: HttpClient,
    private serverUrl: ServerUrlService
  ) { }

  getPaciente(pacienteId: number | string) {
    return this.http.get(`${this.serverUrl.getUrl()}/usuarios/por-paciente-id/${pacienteId}`)
  }

  getUsuarioByIntegracaoId(pacienteId: number | string) {
    return this.http.get(`${this.serverUrl.getUrl()}/usuarios/por-integracao/${pacienteId}`)
  }

  getUsuarios(cpf: string, email: string, datanascimento: string) {
    return this.http.post(`${this.serverUrl.getUrl()}/usuarios/por-tudo`, {
      datanascimento,
      email,
      cpf
    })
  }

  getAgendamentos() {
    return this.http.get(`${this.serverUrl.getUrl()}`)
  }

  vincularUsuarioPaciente(usuarioId: number | string, pacienteId: number | string) {
    return this.http.post(`${this.serverUrl.getUrl()}/usuarios/vincular`, {
      id: usuarioId,
      integracao_id: pacienteId
    })
  }

  desvincularUsuarioPaciente(usuarioId: number | string) {
    return this.http.post(`${this.serverUrl.getUrl()}/usuarios/vincular`, {
      id: usuarioId,
      integracao_id: null
    })
  }

  criarUsuario(infos: CreateUsuarioType) {
    return this.http.post(`${this.serverUrl.getUrl()}/usuarios`, infos)
  }
  
  getAgendamentosByUsuarioId(usuario_id: number, token: string) {
    return this.http.post(`${this.serverUrl.getUrl()}/agendament/usuario`, {
      usuario_id
    }, {
      headers: {
        token,
        sistema: 'OTIMUSCLINIC'
      }
    })
  }

  sistemaTemSamoc() {
    return this.http.get<{ temSamoc: boolean }>(`${this.serverUrl.getUrl()}/integracao/sistema-tem-samoc`)
  }

  trocarPacienteProntuario(pacienteId: string | number, prontuario: string) {
    return this.http.post(`${this.serverUrl.getUrl()}/usuarios/trocar-prontuario/${pacienteId}`, { prontuario })
  }
}
